import BreveTextBook from "../assets/fonts/BreveText-Book.woff"
import WiredMono from "../assets/fonts/WiredMono-Regular.otf"

const fonts = {
  "@font-face": [
    {
      fontFamily: "BreveText",
      src: `url('${BreveTextBook}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
    {
      fontFamily: "WiredMono",
      src: `url('${WiredMono}') format("woff")`,
      fontWeight: 400,
      fontStyle: "normal",
      fontDisplay: "swap",
    },
  ],
}

export default fonts
